export enum ApplicationsUrl {
  ios = "https://apps.apple.com/app/%D1%84%D0%BE%D0%BF%D0%BA%D0%B0%D1%81%D0%B0-%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BD%D0%B8%D0%B9-%D1%80%D1%80%D0%BE/id1571983961",
  android = "https://play.google.com/store/apps/details?id=com.fopkasa",
}
